import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="relative overflow-hidden  bg-gradient-to-r from-[#263283] to-[#ed2924] sm:py-16 md:py-20">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-16 -right-16 w-64 h-64 bg-purple-500 rounded-full opacity-10"></div>
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-indigo-400 rounded-full opacity-5"></div>
        <div className="absolute bottom-0 right-1/3 w-48 h-48 bg-blue-300 rounded-full opacity-10"></div>

        {/* Grid overlay */}
        <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      </div>

      <div className="lg:max-w-7xl mx-auto  pb-12 md:pb-0 sm:pt-6 md:pt-0 pt-20 relative z-10">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-4 px-5 xl:px-0">
          {/* Left Content */}
          <div
            className={` transition-all duration-1000 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-12"
            }`}
          >
            <div className="inline-block mb-4 px-4 py-1 rounded-full bg-indigo-600/30 backdrop-blur border border-indigo-500/30">
              <span className="text-indigo-200 font-medium text-sm">
                The Future of Crypto Trading
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              <span className="block"> Trade Smarter with </span>
              <span className="bg-gradient-to-r from-indigo-300 to-purple-200 bg-clip-text text-transparent">
             GFM's Forex Bots
              </span>
            </h1>

            <p className="text-lg text-indigo-100 mb-8 max-w-xl">
            Our intelligent bots analyze the market and execute trades automatically, helping you earn more with less effort. Whether you're a beginner or a pro, GFM makes Forex trading simple, secure, and profitable.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button onClick={()=>{
                window.location.href ='/registration'
              }} className="px-8 py-4 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-bold rounded-xl shadow-lg shadow-indigo-500/30 transition duration-300 transform hover:-translate-y-1">
                Start Trading Now
              </button>
              {/* <button className="px-8 py-4 bg-transparent border-2 border-indigo-400/30 hover:border-indigo-400/70 text-indigo-100 font-semibold rounded-xl transition duration-300 transform hover:-translate-y-1">
                View Features
              </button> */}
            </div>

            {/* <div className="mt-10 flex items-center gap-6">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 rounded-full bg-indigo-200 border-2 border-indigo-900 flex items-center justify-center text-xs font-bold text-indigo-900">
                  BTC
                </div>
                <div className="w-10 h-10 rounded-full bg-purple-200 border-2 border-indigo-900 flex items-center justify-center text-xs font-bold text-indigo-900">
                  ETH
                </div>
                <div className="w-10 h-10 rounded-full bg-blue-200 border-2 border-indigo-900 flex items-center justify-center text-xs font-bold text-indigo-900">
                  LTC
                </div>
                <div className="w-10 h-10 rounded-full bg-green-200 border-2 border-indigo-900 flex items-center justify-center text-xs font-bold text-indigo-900">
                  +15
                </div>
              </div>
              <p className="text-indigo-200 text-sm">
                <span className="font-bold">10,000+</span> active traders
              </p>
            </div> */}
          </div>

          {/* Right Content - Mobile App Mockup */}
          <motion.div
            animate={{ y: [0, -20, 0] }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <img
              src="/hero1.png"
              alt="App Phone"
              className="w-72 md:w-[600px] rounded-2xl  "
            />
          </motion.div>
        </div>
      </div>

    
      
    </div>
  );
};

export default HeroSection;
